// @flow strict
import React from 'react';
import { Link } from 'gatsby';
import Menu from './Menu';
import styles from './Header.module.scss';
import { useSiteMetadata } from '../../hooks';
import Logo from '../../../static/media/logo/highley-varlet-logo.png';

const Header = () => {
  const { menu } = useSiteMetadata();

  return (
    <div className={styles['header']}>
      <div className={styles['header__logo-wrapper']}>
        <div className={styles['header__logo-wrapper__logo']}>
          <Link className={styles['header__logo-wrapper__logo__link']} to="/">
            <img
              className={styles['header__logo-wrapper__logo__link--img']}
              src={Logo}
              alt="Highley Varlet"
            />
          </Link>
        </div>
      </div>
      <div className={styles['header__menu-wrapper']}>
        <div className={styles['header__menu-wrapper__menu']}>
          <Menu menu={menu} />
        </div>
      </div>
    </div>
  );
};

export default Header;
